import React, { useEffect } from 'react';

export default function ImpersonateScreen() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const tenant = params.get('tenant');
    const tenantId = params.get('tenant_id');
    
    if (token) {
      localStorage.setItem('auth_token', token);
      if (tenant) {
        localStorage.setItem('tenant_slug', tenant);
      }
      if (tenantId) {
        localStorage.setItem('tenant_id', tenantId);
      }
      // Redirect to reload the app with the new token
      window.location.href = '/dashboard';
    } else {
      window.location.href = '/login';
    }
  }, []);

  return (
    <div className="flex h-screen items-center justify-center bg-surface dark:bg-slate-950 transition-colors flex-col">
      <div className="w-10 h-10 border-[3px] border-slate-200 dark:border-slate-800 border-t-primary rounded-full animate-spin mb-4" />
      <p className="text-ink dark:text-slate-300 font-medium">Starting impersonation session...</p>
    </div>
  );
}
